import {Component, Injector, OnInit, Optional} from '@angular/core';

import { DataSource, runtimeEventManager, validateDataSourceCtx } from '@wm/core';
import { IWidgetConfig, provideAsWidgetRef, StylableComponent, styler, ImagePipe, Parent, register } from '@wm/components-base';
import { includes, isEmpty, split } from 'lodash-es';
import { CommonModule } from '@angular/common';

const DEFAULT_CLS = 'app-spinner';

const WIDGET_CONFIG: IWidgetConfig = {
    widgetType: 'wm-spinner',
    hostClass: DEFAULT_CLS,
};

@Component({
    selector: '[wmSpinner]',
    template: `
    <div class="spinner-message">
    <span class="spinner-image animated infinite" [ngClass]="animation" aria-hidden="true"
        [ngStyle]="{width: imagewidth, height: imageheight, backgroundImage: picture? 'url(' + picture + ')' : '', backgroundSize: imagewidth}"
        *ngIf="type === 'image'"></span>
    <i class="spinner-image animated infinite" aria-hidden="true" [ngClass]="[iconclass, animation]" [style.fonSize]="iconsize" *ngIf="type === 'icon'"></i>
    <span class="spinner-text" [innerHTML]="caption" *ngIf="showCaption"></span>
    <div class="spinner-messages" *ngIf="!showCaption && spinnerMessages">
        <p *ngFor="let value of spinnerMessages" [textContent]="value"></p>
    </div>
    </div>`,
    standalone: true,
    imports: [
        CommonModule
    ],
    providers: [
        ImagePipe,
        provideAsWidgetRef(SpinnerComponent)
    ],
    exportAs: 'wmSpinner'
})
export class SpinnerComponent extends StylableComponent implements OnInit {
    static initializeProps = register('wm-spinner');
    public iconclass = '';
    public animation = '';
    public imagewidth: any;
    public imageheight: any;
    public servicevariabletotrack: string;
    public show: boolean;
    picture: string;
    caption: string;
    iconsize: string;
    private _spinnerMessages: any;
    public showCaption = true;
    public type: any;

    public get spinnerMessages() {
        return this._spinnerMessages;
    }

    public set spinnerMessages(newVal) {
        this.showCaption = isEmpty(newVal);
        this._spinnerMessages = newVal;
    }

    private listenOnDataSource() {
        const variables = split(this.servicevariabletotrack, ',');
        runtimeEventManager.on('toggle-variable-state').subscribe((data: any) => {
            const name = data.variable.execute(DataSource.Operation.GET_NAME);
            if (includes(variables, name) && validateDataSourceCtx(data.variable, this.viewParent)) {
                this.widget.show = data.active;
            }
        });
    }

    constructor(inj: Injector, @Optional() viewParent: Parent, private imagePipe: ImagePipe) {
        super(inj, WIDGET_CONFIG, viewParent);
        styler(this.nativeElement, this);
    }

    override onPropertyChange(key: string, nv: any, ov?: any) {
        if (key === 'type') {
          let isImage = nv === 'image';
          let widgetProperties = this.widgetProps;

          widgetProperties['image'].show = widgetProperties['imagewidth'].show = widgetProperties['imageheight'].show = isImage;
          widgetProperties['iconclass'].show = widgetProperties['iconsize'].show = !isImage;
          runtimeEventManager.emit('wms:refresh-properties-panel');
        } else if (key === 'image') {
            this.picture = this.imagePipe.transform(nv);
        } else if (key === 'animation') {
            if (nv === 'spin') {
                this.animation = 'fa-spin';
            } else {
                this.animation = nv || '';
            }
        } else {
            super.onPropertyChange(key, nv, ov);
        }
    }

    override ngOnInit() {
        super.ngOnInit();
        // if variables are to be listened to, hide the widget and set the listener
        if (this.servicevariabletotrack) {
            this.widget.show = false;
            this.listenOnDataSource();
        }
    }
}
